export default {
  properties: {
    mixinShowProp: {
      type: Boolean,
      value: false
    }
  },
  watch: {
    mixinShowProp: {
      handler(next, prev) {
        if(next && !prev) this.onShowHandle()
      },
      immediate: true
    }
  },
  pageLifetimes: {
    show() {
      if(this.mixinShowProp) this.onShowHandle()
    }
  },
  methods: {
    // default onShowHandle
    onShowHandle() {
      console.log('-------- You should set your own onShowHandle --------')
    }
  }
}